var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6901 10.6104L53.9404 17.3536L66.1355 15.9996L62.8901 27.8323L67.9456 39.0117L55.6893 39.5823L46.6189 47.8452L42.2896 36.3639L31.6282 30.2912L41.2088 22.6259L43.6901 10.6104ZM7.12029 0.36084L12.8934 4.15826L19.7605 3.39568L17.9335 10.0599L20.7802 16.3565L13.8782 16.677L8.7701 21.3306L6.33139 14.8654L0.327515 11.445L5.72287 7.12807L7.12029 0.36084Z",
    fill: "#F7CD46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.b51bbda21c2a5a2ab58b431e07e1d9ad.svg";
export { ForwardRef as ReactComponent };